import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { Content } from 'core/layouts';
import { BaasicFormControls, BasicInput, BaasicButton, BaasicFieldDropdown, BaasicDropdown, NumericInputField, BaasicModal } from 'core/components';
import { PatientTemplateCustomOrderingDoctorAdd } from "application/niko-patient/components";
import { Button } from "@progress/kendo-react-buttons";
import { uuid } from "core/utils";
import { FacilityOrderTemplatePNMissingInformationModal } from "application/facility-order/components";
import { NikoTemplateMissingDocumentNoteModal, PatientTemplateClinicalStatusNoteModal } from "application/niko-patient/components";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { observer } from 'mobx-react';
import { orderingDoctorItemRender, orderingDoctorValueRender } from 'themes/components/select/OrderingDoctorDropdownRender';

const TooltipContent = observer(({ initianValue, history, fieldName }) => {
	if (!history || history.fieldName !== fieldName) return null;
	const date = new Date(history.eventDate + "Z");
	const formattedDate = date.toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true }).replace(',', '');
	return (<div>
		<div>Previous: {initianValue ? initianValue : 'blank'}</div>
		<div style={{ fontSize: '11px', opacity: 0.75 }}>{history ? history.userName + ', ' + formattedDate : '\u2014'}</div>
	</div>);
});

function NikoFacilityOrderUSIntakeClinicalInformationModalTemplate({ nikoFacilityOrderUSIntakeClinicalInformationModalStore, t }) {
	const {
		loadingData,
		patientTemplate,
		contentLoading,
		form,
		modalParams,
		clinicalStatusStore,
		doctorStore,
		dxCode1Store,
		dxCode2Store,
		dxCode3Store,
		dxCode4Store,
		dxCode5Store,
		dxCode6Store,
		dxCode7Store,
		dxCode8Store,
		missingDocumentStore,
		nikoPatientDetail,
		generateMedicalNecessityForm,
		generateStandardWrittenOrder,
		generateMedicalNecessityFormAndStandardWrittenOrder,
		openNikoTemplateMissingDocumentNoteModal,
		nikoTemplateMissingDocumentNoteModal,
		openPatientTemplateClinicalStatusNoteModal,
		patientTemplateClinicalStatusNoteModal,
		templatePNMissingInformationModal,
		disabled,
		syncOrderingDoctors,
		isSyncInProgress,
		item,
		getFieldHistory,
		missingDocsPreviousValue,
		mappedMissingDocuments,
		updateMissingDocuments,
	} = nikoFacilityOrderUSIntakeClinicalInformationModalStore;
	
	const onTargetFocus = (e) => {
		e.target.select();
	};
	
	const initDxCode1= patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes.find(x => x.Order === 1);
	const initDxCode2= patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes.find(x => x.Order === 2);
	const initDxCode3= patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes.find(x => x.Order === 3);
	const initDxCode4= patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes.find(x => x.Order === 4);
	const initDxCode5= patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes.find(x => x.Order === 5);
	const initDxCode6= patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes.find(x => x.Order === 6);
	const initDxCode7= patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes.find(x => x.Order === 7);
	const initDxCode8= patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes.find(x => x.Order === 8);

	const dxCode1 = patientTemplate.patientTemplateDiagnosisCodes && patientTemplate.patientTemplateDiagnosisCodes.find(x => x.order === 1);
	const dxCode2 = patientTemplate.patientTemplateDiagnosisCodes && patientTemplate.patientTemplateDiagnosisCodes.find(x => x.order === 2);
	const dxCode3 = patientTemplate.patientTemplateDiagnosisCodes && patientTemplate.patientTemplateDiagnosisCodes.find(x => x.order === 3);
	const dxCode4 = patientTemplate.patientTemplateDiagnosisCodes && patientTemplate.patientTemplateDiagnosisCodes.find(x => x.order === 4);
	const dxCode5 = patientTemplate.patientTemplateDiagnosisCodes && patientTemplate.patientTemplateDiagnosisCodes.find(x => x.order === 5);
	const dxCode6 = patientTemplate.patientTemplateDiagnosisCodes && patientTemplate.patientTemplateDiagnosisCodes.find(x => x.order === 6);
	const dxCode7 = patientTemplate.patientTemplateDiagnosisCodes && patientTemplate.patientTemplateDiagnosisCodes.find(x => x.order === 7);
	const dxCode8 = patientTemplate.patientTemplateDiagnosisCodes && patientTemplate.patientTemplateDiagnosisCodes.find(x => x.order === 8);

	const tagRender = (tagData, li) => React.cloneElement(li, { children: <span key={uuid()} onClick={() => openNikoTemplateMissingDocumentNoteModal(tagData.data[0])}>{tagData.data[0].name}</span> });

	const nikoInputData =  item && {item: item, patientTemplate: patientTemplate, getFieldHistory: getFieldHistory };
	const dxCodeDropdownItemRender = (li, itemProps) => {
		const itemName = itemProps && itemProps.dataItem.name;
		const itemChildren = (
			<span style={{ display: "flex", flexDirection: "column", width: "100%", }}>
				<span style={{ flex: "1" }}> {li.props.children} </span>
				<span style={{ fontSize: "12px" }}>{itemName} </span>
			</span>
		);
		return React.cloneElement(li, li.props, itemChildren);
	}
	
	return (
		<div style={{ minHeight: 444 }}>
			<Content loading={contentLoading || loadingData}>
				<div className="modal__header">
					<h3 className='modal__header__title'>Clinical Information</h3>
				</div>
				<div className='u-flex--align-end u-flex--justify-end u-mar--bottom--sml'>
					{
						nikoPatientDetail.eligibilityStatus && nikoPatientDetail.eligibilityStatus.name == "Eligible" &&
						<React.Fragment>
							{patientTemplate.clinicalStatus && patientTemplate.clinicalStatus.name != "Covered" && patientTemplate.clinicalStatus.name != "Prior Auth Obtained" && patientTemplate.clinicalStatus.name != "Does Not Meet Insurance Criteria" &&
								<div>
									<Button className="btn btn--link btn--icon--sml-med" icon="u-icon u-icon--med u-icon--us-note" onClick={() => openPatientTemplateClinicalStatusNoteModal()} disabled={disabled || form.submitting} />
									{/* data-tooltip-content="Clinical Status Note"  */}
								</div>
							}
							<div className='is-blue'>
								<BaasicFieldDropdown className="k-dropdown--primary k-dropdown--nowrap" field={form.$('clinicalStatusId')} store={clinicalStatusStore} toolTipPlace='left' disabled={disabled}
								isNiko={true}
								showChangeFlag={item && !patientTemplate.isNew && !nikoPatientDetail.isNew && patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.ClinicalStatusId != item.clinicalStatusId} 
								nikoInputData={item && { ...nikoInputData, fieldName: 'ClinicalStatusId', initialValue: patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.ClinicalStatusId, currentValue: item.clinicalStatusId, initialDisplayName: patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.ClinicalStatusName }}
							/>
							</div>
						</React.Fragment>
					}
					<div className="status--sqare__wrapper u-mar--left--tny">
						<Button className="btn btn--icon btn--icon--sml-med btn--light" icon="u-icon u-icon--med u-icon--clinical-review" disabled={disabled} />
					</div>
				</div>
				<div className="modal__body is-blue">
					<div className="row">
						<div className="form__group col col-lrg-12">
							<BasicInput field={form.$('salesOrderNote')} toolTipPlace='left' disabled={disabled}
							isNiko={true}
							showChangeFlag={item && !patientTemplate.isNew && !nikoPatientDetail.isNew && patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.SalesOrderNote != item.salesOrderNote} 
							nikoInputData={item && { ...nikoInputData, fieldName: 'SalesOrderNote', initialValue: patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.SalesOrderNote, currentValue: item.salesOrderNote }}
							/>
						</div>
					</div>
					<div className="row">
						<div className="form__group col col-lrg-12">
							<BasicInput field={form.$('expirationDate')} toolTipPlace='left' disabled={disabled} 
							isNiko={true}
							showChangeFlag={item && !patientTemplate.isNew && !nikoPatientDetail.isNew && patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.ExpirationDate != item.expirationDate} 
							nikoInputData={item && {...nikoInputData, fieldName: 'ExpirationDate', initialValue: patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.ExpirationDate, currentValue: item.expirationDate }}
							/>
							</div>
					</div>
					<div className="row" >
						<div className="form__group col col-lrg-3">
							<BaasicFieldDropdown field={form.$('dxCode1')} store={dxCode1Store} allowEmpty={true} itemRender={dxCodeDropdownItemRender} disabled={disabled}
							isNiko={true}
							showChangeFlag={item && !patientTemplate.isNew && !nikoPatientDetail.isNew && (initDxCode1 ? initDxCode1.DiagnosisCodeId : '') != (dxCode1 ? dxCode1.diagnosisCodeId : '')}
							nikoInputData={item && {...nikoInputData, fieldName: 'DxCode1', initialValue: initDxCode1 && initDxCode1.DiagnosisCode && initDxCode1.DiagnosisCode.code, currentValue: dxCode1Store.value && dxCode1Store.value.id }}
							/>
						</div>
						<div className="form__group col col-lrg-3">
							<BaasicFieldDropdown field={form.$('dxCode2')} store={dxCode2Store} allowEmpty={true} itemRender={dxCodeDropdownItemRender} disabled={disabled}
							isNiko={true}
							showChangeFlag={item && !patientTemplate.isNew && !nikoPatientDetail.isNew && (initDxCode2 ? initDxCode2.DiagnosisCodeId : '') != (dxCode2 ? dxCode2.diagnosisCodeId : '')} 
							nikoInputData={item && {...nikoInputData, fieldName: 'DxCode2', initialValue: initDxCode2 && initDxCode2.DiagnosisCode && initDxCode2.DiagnosisCode.code, currentValue: dxCode2Store.value && dxCode2Store.value.id }}
							/>
						</div>
						<div className="form__group col col-lrg-3 ">
							<BaasicFieldDropdown field={form.$('dxCode3')} store={dxCode3Store} allowEmpty={true} itemRender={dxCodeDropdownItemRender} disabled={disabled}
							isNiko={true}
							showChangeFlag={item && !patientTemplate.isNew && !nikoPatientDetail.isNew && (initDxCode3 ? initDxCode3.DiagnosisCodeId : '') != (dxCode3 ? dxCode3.diagnosisCodeId : '')}
							nikoInputData={item && {...nikoInputData, fieldName: 'DxCode3', initialValue: initDxCode3 && initDxCode3.DiagnosisCode && initDxCode3.DiagnosisCode.code, currentValue: dxCode3Store.value && dxCode3Store.value.id }}
							/>
						</div>
						<div className="form__group col col-lrg-3">
							<BaasicFieldDropdown field={form.$('dxCode4')} toolTipPlace='left' store={dxCode4Store} allowEmpty={true} itemRender={dxCodeDropdownItemRender} disabled={disabled}
							isNiko={true}
							showChangeFlag={item && !patientTemplate.isNew && !nikoPatientDetail.isNew && (initDxCode4 ? initDxCode4.DiagnosisCodeId : '') != (dxCode4 ? dxCode4.diagnosisCodeId : '')}
							nikoInputData={item && {...nikoInputData, fieldName: 'DxCode4', initialValue: initDxCode4 && initDxCode4.DiagnosisCode && initDxCode4.DiagnosisCode.code, currentValue: dxCode4Store.value && dxCode4Store.value.id }}
							/>
						</div>
					</div>
					<div className="row" >
						<div className="form__group col col-lrg-3">
							<BaasicFieldDropdown field={form.$('dxCode5')} store={dxCode5Store} allowEmpty={true} itemRender={dxCodeDropdownItemRender} disabled={disabled}
							isNiko={true}
							showChangeFlag={item && !patientTemplate.isNew && !nikoPatientDetail.isNew && (initDxCode5 ? initDxCode5.DiagnosisCodeId : '') != (dxCode5 ? dxCode5.diagnosisCodeId : '')}
							nikoInputData={item && {...nikoInputData, fieldName: 'DxCode5', initialValue: initDxCode5 && initDxCode5.DiagnosisCode && initDxCode5.DiagnosisCode.code, currentValue: dxCode5Store.value && dxCode5Store.value.id }}
							/>
						</div>
						<div className="form__group col col-lrg-3">
							<BaasicFieldDropdown field={form.$('dxCode6')} store={dxCode6Store} allowEmpty={true} itemRender={dxCodeDropdownItemRender} disabled={disabled}
							isNiko={true}
							showChangeFlag={item && !patientTemplate.isNew && !nikoPatientDetail.isNew && (initDxCode6 ? initDxCode6.DiagnosisCodeId : '') != (dxCode6 ? dxCode6.diagnosisCodeId : '')}
							nikoInputData={item && {...nikoInputData, fieldName: 'DxCode6', initialValue: initDxCode6 && initDxCode6.DiagnosisCode && initDxCode6.DiagnosisCode.code, currentValue: dxCode6Store.value && dxCode6Store.value.id }}
							/>
						</div>
						<div className="form__group col col-lrg-3 ">
							<BaasicFieldDropdown field={form.$('dxCode7')} store={dxCode7Store} allowEmpty={true} itemRender={dxCodeDropdownItemRender} disabled={disabled}
							isNiko={true}
							showChangeFlag={item && !patientTemplate.isNew && !nikoPatientDetail.isNew && (initDxCode7 ? initDxCode7.DiagnosisCodeId : '') != (dxCode7 ? dxCode7.diagnosisCodeId : '')}
							nikoInputData={item && {...nikoInputData, fieldName: 'DxCode7', initialValue: initDxCode7 && initDxCode7.DiagnosisCode && initDxCode7.DiagnosisCode.code, currentValue: dxCode7Store.value && dxCode7Store.value.id }}
							/>
						</div>
						<div className="form__group col col-lrg-3">
							<BaasicFieldDropdown field={form.$('dxCode8')} toolTipPlace='left' store={dxCode8Store} allowEmpty={true} itemRender={dxCodeDropdownItemRender} disabled={disabled}
							isNiko={true}
							showChangeFlag={item && !patientTemplate.isNew && !nikoPatientDetail.isNew && (initDxCode8 ? initDxCode8.DiagnosisCodeId : '') != (dxCode8 ? dxCode8.diagnosisCodeId : '')} 
							nikoInputData={item && {...nikoInputData, fieldName: 'DxCode8', initialValue: initDxCode8 && initDxCode8.DiagnosisCode && initDxCode8.DiagnosisCode.code, currentValue: dxCode8Store.value && dxCode8Store.value.id }}
							/>
						</div>
					</div>
					<div className="row">

						<div className="form__group col col-med-6">
							<div className="form__group__label">
								{t(form.$('orderingDoctorId').label)}
								<i title='Sync Niko Ordering Doctors' className={`u-icon u-icon--sml u-icon--synchronize--${isSyncInProgress ? "grey" : "primary"} u-mar--left--tny`} onClick={() => syncOrderingDoctors()}></i>
							</div>
							<BaasicFieldDropdown field={form.$('orderingDoctorId')} store={doctorStore} allowEmpty={true} labelDisplayed={false} disabled={disabled} itemRender={orderingDoctorItemRender} valueRender={orderingDoctorValueRender}
							isNiko={true}
							showChangeFlag={item && !patientTemplate.isNew && !nikoPatientDetail.isNew && patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.OrderingDoctorId != item.orderingDoctorId} 
							nikoInputData={item && {...nikoInputData, fieldName: 'OrderingDoctorId', initialValue: patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.OrderingDoctorId, currentValue: item.orderingDoctorId, initialDisplayName: patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.DoctorName }}
							/>
						</div>
						<div className="form__group col col-lrg-3">
							<NumericInputField field={form.$('height')} setDefaultType={true} showSpinners={false} onClick={(e) => onTargetFocus(e)} disabled={disabled} 
							isNiko={true}
							showChangeFlag={!patientTemplate.isNew && !nikoPatientDetail.isNew && nikoPatientDetail.initialNikoPatientDetail && nikoPatientDetail.initialNikoPatientDetail.Height != nikoPatientDetail.height} 
							nikoInputData={item && {...nikoInputData, item: nikoPatientDetail, fieldName: 'Height', initialValue: nikoPatientDetail.initialNikoPatientDetail.Height, currentValue: nikoPatientDetail.height }}
							/>
						</div>
						<div className="form__group col col-lrg-3">
							<NumericInputField field={form.$('weight')} setDefaultType={true} showSpinners={false} onClick={(e) => onTargetFocus(e)} disabled={disabled} toolTipPlace='left'
							isNiko={true}
							showChangeFlag={!patientTemplate.isNew && !nikoPatientDetail.isNew && nikoPatientDetail.initialNikoPatientDetail && nikoPatientDetail.initialNikoPatientDetail.Weight != nikoPatientDetail.weight} 
							nikoInputData={item && {...nikoInputData, item: nikoPatientDetail, fieldName: 'Weight', initialValue: nikoPatientDetail.initialNikoPatientDetail.Weight, currentValue: nikoPatientDetail.weight }}
							/>
							</div>
					</div>
					<div className="row">
						<div className="form__group col col-lrg-12">
							<div className="form__group__label">{t('FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.MISSING_DOCUMENTS_LABEL')}</div>
							<div className="u-position--rel">
								<ReactTooltip positionStrategy="fixed" id={"registerTipMissingDocs" + patientTemplate.id} place="left" delayShow={600} render={() => <TooltipContent initianValue={missingDocsPreviousValue != null ? missingDocsPreviousValue : undefined} history={item && item.history} fieldName={"PatientTemplateMissingDocuments"} />} />
								{!patientTemplate.isNew && !nikoPatientDetail.isNew && missingDocsPreviousValue != null &&
									<i className="input--change--text opacity-50" data-tooltip-id={"registerTipMissingDocs" + patientTemplate.id} onMouseEnter={async () => await getFieldHistory(item, 'PatientTemplateMissingDocuments', patientTemplate.patientTemplateMissingDocuments && patientTemplate.patientTemplateMissingDocuments.map(x => x.missingDocumentId).join(','))} data-tooltip-content="" ></i>}
								<BaasicDropdown
									store={missingDocumentStore}
									value={mappedMissingDocuments ? mappedMissingDocuments.slice() : []}
									multi={true}
									tagRender={tagRender}
									autoClose={true}
									disabled={disabled}
									onChange={(e) => { updateMissingDocuments(e.target.value); }}
								/>
							</div>
						</div>
					</div>

					<label className="form__group__label">Generate Documents: </label>
					<div className="u-flex--default btn--grouped">
						<BaasicButton
							onlyIcon={true}
							className='btn btn--sml btn--light t u-mar--right--tny'
							label='SWO & PN'
							icon="u-icon u-icon--sml u-icon--download--brand"
							onClick={() => generateMedicalNecessityFormAndStandardWrittenOrder()}
						/>
						<BaasicButton
							className='btn btn--sml btn--light t u-mar--right--tny'
							label='SWO'
							onClick={() => generateStandardWrittenOrder()}
						/>
						<BaasicButton
							className='btn btn--sml btn--light t u-mar--right--tny'
							label='PN'
							onClick={() => generateMedicalNecessityForm()}
						/>
						<PatientTemplateCustomOrderingDoctorAdd patientTemplate={patientTemplate} disabled={disabled} />
					</div>
				</div>
				<div className='u-separator--primary  u-mar--top--sml'></div>
				<div className='modal__footer is-right'>
					<BaasicButton
						className='btn btn--med btn--light'
						label={t('EDIT_FORM_LAYOUT.CANCEL')}
						onClick={() => modalParams.close()}
						disabled={disabled || form.submitting || form.validating}
					/>
					<BaasicFormControls
						form={form}
						className='btn btn--med btn--primary'
						onSubmit={form.onSubmit}
						disabled={disabled || form.submitting || form.validating}
						label={t('EDIT_FORM_LAYOUT.SAVE')}
					/>
				</div>

				<BaasicModal modalParams={nikoTemplateMissingDocumentNoteModal} className="modal__content modal--med">
					<NikoTemplateMissingDocumentNoteModal />
				</BaasicModal>
				<BaasicModal modalParams={patientTemplateClinicalStatusNoteModal} className="modal__content modal--med">
					<PatientTemplateClinicalStatusNoteModal />
				</BaasicModal>
				<BaasicModal modalParams={templatePNMissingInformationModal} className="modal__content modal--med">
					<FacilityOrderTemplatePNMissingInformationModal />
				</BaasicModal>
			</Content>
		</div>
	)
}

NikoFacilityOrderUSIntakeClinicalInformationModalTemplate.propTypes = {
	nikoFacilityOrderUSIntakeClinicalInformationModalStore: PropTypes.object,
	t: PropTypes.func
};

export default defaultTemplate(NikoFacilityOrderUSIntakeClinicalInformationModalTemplate);
